import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { BookingTravellerTicketComponent } from "./booking-traveller-ticket.component";
import { SectorsAirSimpleListModule } from "libraries/component/sectors-air-simple-list/sectors-air-simple-list.module";
import { DatePipeModule } from "libraries/date/date.module";
import { SectorsAirDetailsListModule } from 'libraries/component/sectors-air-details-list/sectors-air-details-list.module';
import { BookingTravellerTicketService } from './services/booking-traveller-ticket.service';
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { BtnModule } from "libraries/ui_button/btn.module";
import { RulesSearchFormModule } from "libraries/component/sectors-air-details-list/components/rules-search-form/rules-search-form.module";
import { AirTicketResourceModule } from "libraries/service/resources/air-ticket-resource/air-ticket-resource.module";
import { LoaderModule } from "libraries/component/loader/loader.module";
import { NotificationModule } from "libraries/component/notification/notification.module";
import { ErrorTracingModule } from "libraries/service/error-tracing/error-tracing.module";
import { PermissionModule } from "libraries/permission/permission.module";
import { PriceModule } from "libraries/component/price/price.module";
import {
    BookingTravellerTicketServiceModule
} from "libraries/component/booking-information/components/booking-traveller-card/components/booking-traveller/components/booking-traveller-ticket/services/booking-traveller-ticket-service.module";

@NgModule({
    imports: [
        AirTicketResourceModule,
        BtnModule,
        CommonModule,
        DatePipeModule,
        ErrorTracingModule,
        FontAwesomeModule,
        LoaderModule,
        NotificationModule,
        PermissionModule,
        PriceModule,
        RulesSearchFormModule,
        SectorsAirDetailsListModule,
        SectorsAirSimpleListModule,
        BookingTravellerTicketServiceModule,
    ],
    exports: [
        BookingTravellerTicketComponent,
    ],
    declarations: [
        BookingTravellerTicketComponent,
    ],
})
export class BookingTravellerTicketModule {
}
